// Polyfill global to resolve "global is not defined" errors in dependencies
if (typeof (window as any).global === 'undefined') {
    (window as any).global = window;
}

export { };
